import type { APIInstance } from "./apiService";

export class CaseUsersService {
  private api: APIInstance;

  constructor(api: APIInstance) {
    this.api = api;
  }

  async addAnalyst(caseId: string, userId: string): Promise<void> {
    await this.api.post(`/cases/${caseId}/analysts`, { user_id: userId });
  }

  async removeAnalyst(caseId: string, userId: string): Promise<void> {
    await this.api.delete(`/cases/${caseId}/analysts/${userId}`);
  }

  async addQcReviewer(caseId: string, userId: string): Promise<void> {
    await this.api.post(`/cases/${caseId}/users/`, {
      role_type: "qc_reviewer",
      user_ids: [userId],
    });
  }

  async removeQcReviewer(caseId: string, userId: string): Promise<void> {
    await this.api.delete(`/cases/${caseId}/users/${userId}/roles/qc_reviewer`);
  }
}
